import axios from 'axios'
import {jsonHeader} from '@/helpers/axiosHeaders'
import VueCookies from 'vue-cookies'
import Vue from 'vue'
import qs from "qs";
const state = {
    user: {
        permission: []
    },
    isLoaded: false,
    cookiesWarning: false,
    hasCookiesFirstVisit: false,
    firstVisitRedirect: false,
    tech: [],
    chef: [],
}

// getters
const getters = {
    getUser() {
        return state.user;
    },
    firstVisit(){
        let result = VueCookies.get('firstVisit') || state.hasCookiesFirstVisit;
        if(result !== null) {
            if(result === 'false') {
                result = false
            } else {
                result = true
            }
        } else {
            result = true
        }
        return result;
    }
}

const actions = {
    getCurrent(context, data) {
        return new Promise((resolve, reject) => {
            if(localStorage.getItem('token') !== 'false' && localStorage.getItem('token') !== null && localStorage.getItem('token') !== undefined) {
                axios.get(process.env.VUE_APP_API_PATH+'/user/users/', {
                    headers: {'Content-Type': 'application/json;charset=utf-8','Authorization': localStorage.getItem('token') !== 'false' && localStorage.getItem('token') !== null && localStorage.getItem('token') !== undefined ? localStorage.getItem('token') : false},
                    withCredentials: true,

                }).then(response => {
                    context.commit('setLoaded', true);
                    if(typeof response.data === 'object' && +response.data.error === 0) {
                        if(response.data.result.user) {
                            context.commit('setUser', response.data.result);
                            let access_rights = response.data.result.user.access_rights;
                            if(data.routeName != 'user-contract' && !access_rights.is_owner && !access_rights.is_moderator){   
                                context.commit('auth/setIsNoSuccessSection', true, {root: true});
                            }
                        } else {
                            context.dispatch('auth/clearUserAuthInfo', false, { root: true });
                        }

                    } else {
                        if( +response.data.error===402){
                            context.commit('auth/setBanPermanent',true, { root: true });
                            context.commit('setUser', response.data.result);
                        } else {
                            if( +response.data.error===401){
                                context.dispatch('auth/logout',{},{root:true})
                            }
                            context.dispatch('auth/clearUserAuthInfo', false, { root: true });
                        }
                    }
                    resolve();
                }).catch(function (error) {
                    context.commit('popups/open', {name: context.rootState.popups.items.somethingWentWrong.name}, {root: true});
                    resolve();
                });
            } else {
                axios.get(process.env.VUE_APP_API_PATH+'/public/users/', {
                    headers: jsonHeader,
                    withCredentials: true,
                }).then(response => {
                    context.commit('setLoaded', true);
                    if(response.data.error > 0) {
                        switch (+response.data.error ) {
                            case 403:
                                context.commit('auth/setBan',true, { root: true });
                                break;
                            case 402:
                                context.commit('auth/setBanPermanent',true, { root: true });
                                context.commit('setUser', response.data.result);
                                break;
                        }

                    }
                }).catch(function (error) {
                    context.commit('popups/open', {name: context.rootState.popups.items.somethingWentWrong.name}, {root: true});
                });
            }
        });
    },
    save(context){
        axios.put(process.env.VUE_APP_API_PATH+'/user/users/',{},{
            headers: {'Content-Type': 'application/json;charset=utf-8','Authorization': localStorage.getItem('token') !== 'false' && localStorage.getItem('token') !== null && localStorage.getItem('token') !== undefined ? localStorage.getItem('token') : false},
            withCredentials: true,
            params: {
                firstName: context.rootState.auth.forms.registration.fields.firstName.value,
                lastName: context.rootState.auth.forms.registration.fields.lastName.value,
                secondName: context.rootState.auth.forms.registration.fields.secondName.value,
                email: context.rootState.auth.forms.registration.fields.email.value,
            },
            paramsSerializer: function(params) {
                return qs.stringify(params, {arrayFormat: 'repeat'})
            },
        }).then(response => {
            if(typeof response.data === 'object' && +response.data.error === 0) {
                context.commit('users/setUser',response.data.result,{root:true});
            } else {
                if( +response.data.error===401){
                    context.dispatch('auth/logout',{},{root:true})
                }
            }
        }).catch(function (error) {
            context.commit('popups/open', {name: context.rootState.popups.items.somethingWentWrong.name}, {root: true});
        });
    },
    checkPhone(context,data){
        return new Promise((resolve, reject) => {
            axios.get(process.env.VUE_APP_API_PATH+'/public/users/',{
                headers: {'Content-Type': 'application/json;charset=utf-8'},
                withCredentials: true,
                params: {
                    checkPhone: true,
                    phone: data.phone,
                },
                paramsSerializer: function(params) {
                    return qs.stringify(params, {arrayFormat: 'repeat'})
                },
            }).then(response => {
                if(typeof response.data === 'object' && +response.data.error === 0) {
                    resolve(response.data.result.status);
                } else {
                    reject();
                }
            }).catch(function (error) {
                context.commit('popups/open', {name: context.rootState.popups.items.somethingWentWrong.name}, {root: true});
                reject();
        });
        });
    },
    getCookiesWarning(context){
        let warning = VueCookies.get('cookiesWarning');
        if(warning !== null) {
            if(warning === 'false') {
                warning = false
            }
            context.commit('setCookiesWarning', warning);
        } else {
            context.commit('setCookiesWarning', true);
        }
    }
}

const mutations = {
    setUser(state, data) {
        if(typeof data === 'object' && data.user !== undefined) {
            Vue.set(state,'user',data.user);
        }
        if(typeof data === 'object' && data.chef !== undefined) {
            Vue.set(state,'chef',data.chef);
        }
        if(typeof data === 'object' && data.tech !== undefined) {
            Vue.set(state,'tech',data.tech);
        }
    },
    setCookiesWarning(state, data) {
        Vue.set(state,'cookiesWarning', data);
    },
    hideCookiesWarning(state) {
        Vue.set(state,'cookiesWarning', false);
        VueCookies.set('cookiesWarning',false, 31104000);// 1 year
    },
    setCookiesFirstVisit(){
        VueCookies.set('firstVisit',false, 31104000*5);// 5 year
        state.hasCookiesFirstVisit = true;
        state.firstVisitRedirect = true;
    },

    unsetFirstVisitRedirect(){
        state.firstVisitRedirect = false;
    },
    pushOpinion(state, data) {
        if(state.user.opinions === undefined){
            Vue.set(state.user,'opinions', []);
        }
        state.user.opinions.push({
            id: data.id,
            action: data.action,
        });
    },
    setLoaded(state, data) {
        Vue.set(state,'isLoaded', data);
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}